import {createAction} from 'typesafe-actions';

export const mapSceneOpenBridgeGraphDialog = createAction(
    'OPEN_BRIDGE_GRAPH_DIALOG',
    (action) => (isrsCode: string) => action({isrsCode}),
);
